export default [
    {
        "name": "United States",
        "code": 840,
        "child": [
            {
                "name": "California",
                "code": 84001,
                "child": [
                    {
                        "name": "Los Angeles County",
                        "code": 8400101,
                        "child": [
                            { "name": "Los Angeles City", "code": 84001011 },
                            { "name": "Santa Monica", "code": 84001012 },
                            { "name": "Beverly Hills", "code": 84001013 }
                        ]
                    },
                    {
                        "name": "San Francisco",
                        "code": 8400102,
                        "child": [
                            { "name": "Financial District", "code": 84001021 },
                            { "name": "SOMA", "code": 84001022 }
                        ]
                    }
                ]
            },
            {
                "name": "New York",
                "code": 84002,
                "child": [
                    {
                        "name": "New York City",
                        "code": 8400201,
                        "child": [
                            { "name": "Manhattan", "code": 84002011 },
                            { "name": "Brooklyn", "code": 84002012 },
                            { "name": "Queens", "code": 84002013 }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "United Kingdom",
        "code": 826,
        "child": [
            {
                "name": "Greater London",
                "code": 82601,
                "child": [
                    {
                        "name": "London",
                        "code": 8260101,
                        "child": [
                            { "name": "City of Westminster", "code": 82601011 },
                            { "name": "Camden", "code": 82601012 }
                        ]
                    }
                ]
            }
        ]
    }
]
